import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

const state = {
  targetedUsers: [],
};

const getters = {
  targetedUsers: (state) => state.targetedUsers,
};

const actions = {
  async getTargetedUsers({ commit }, { globalOrganisationID, params }) {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get(
      `${getApiClientUrl()}/v3/pt/history/globalOrganisationID/${globalOrganisationID}/stats/targets?${filterParams.toString()}`,
    );

    commit("setTargetedUsers", res.data.data);
  },
};

const mutations = {
  setTargetedUsers: (state, data) => (state.targetedUsers = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
